export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/session_musicians.61917e3.svg";